import styled from 'styled-components';

import { HOME, MOBILE, SPACE, WEBSITE_ANALYTICS } from '../../../../theme/tokens';
import { Text } from '../../../../components';

/** The tiles side by side, `$cols` per row (rows stay balanced: five tiles are three and two); two per row on a
 *  phone. */
export const Grid = styled.ul<{ $cols: number }>`
  list-style: none;
  margin: ${SPACE[0]};
  padding: ${SPACE[4]} ${SPACE[0]} ${SPACE[4]};
  display: grid;
  grid-template-columns: repeat(${({ $cols }) => $cols}, minmax(0, 1fr));
  gap: ${SPACE[8]};

  ${MOBILE} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`;

export const Tile = styled.li`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[4]};
  min-width: 0;
  padding: ${SPACE[12]};
  /* A card on a card: the inner panel fill of the trend chart, no outline. */
  background: ${HOME.panel};
  border-radius: 16px;
`;

/** The tile's picture (a GlyphBadge), a little apart from its name. */
export const GlyphSlot = styled.span`
  display: inline-flex;
  margin-bottom: ${SPACE[4]};
`;

export const Name = styled(Text)`
  font-size: 13px;
  font-weight: 500;
  color: ${HOME.t400};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

/** The share and its change, side by side (the change wraps under on a narrow tile). */
export const ValueRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: ${SPACE[4]} ${SPACE[8]};
`;

export const Value = styled(Text)`
  font-size: 22px;
  font-weight: 600;
  line-height: 1.15;
  color: ${HOME.t50};
  white-space: nowrap;
`;

export const Note = styled(Text)`
  font-size: 12px;
  color: ${HOME.t500};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Track = styled.div`
  height: 4px;
  margin-top: ${SPACE[8]};
  border-radius: 999px;
  background: ${WEBSITE_ANALYTICS.barTrack};
  overflow: hidden;
`;

/** A row's share: a neutral bar (the accent colour is kept for the charts and the headline figures). */
export const Fill = styled.div<{ $share: number }>`
  height: 100%;
  width: ${({ $share }) => `${Math.max(2, Math.round($share * 100))}%`};
  border-radius: inherit;
  background: ${HOME.t400};
`;

export const Empty = styled(Text)`
  display: block;
  padding: ${SPACE[16]} ${SPACE[4]};
  font-size: 14px;
  color: ${HOME.t400};
`;
